import ReactLink from 'react/lib/ReactLink'

function updateState (storeKey, keyPath, transform, value) {
  let state = this.state[storeKey]

  if (transform) {
    state = state.withMutations(data => {
      transform(data, keyPath, value)
    })
  }

  state = state.setIn(keyPath, value)
  this.setState({ [storeKey]: state })
}

/**
 * This provices LinkedStateMixin for Immutable objects and two-way databinding
 * @param  {Object}   component     a React component instance
 * @param  {String}   storeKey      the key on the store that holds immutable data
 * @param  {Object}   transformers  transform field values
 * @return {Function}
 */
export default function createLinkToImmutable (component, storeKey, transformers = {}) {
  /**
   * Returns a function that takes keyPaths
   * @param  {String|Array} keyPath     accepts ['key', 'nestedKey'] or 'key.nestedKey'
   * @return {Object}       a ReactLink instance
   */
  return keyPath => {
    if (!Array.isArray(keyPath)) keyPath = keyPath.split('.')
    const value = component.state[storeKey].getIn(keyPath)
    const transform = transformers[keyPath[0]] && ::transformers[keyPath[0]]

    return new ReactLink(
      value,
      updateState.bind(component, storeKey, keyPath, transform)
    )
  }
}



// WEBPACK FOOTER //
// ./modules/utils/createLinkToImmutable.js